import { IonIcon, IonItem, useIonAlert, useIonToast } from "@ionic/react";
import { notificationsOutline } from "ionicons/icons";
import { useDispatch } from "react-redux";
import { notifySigners } from "../../../store/documentList/actions/notifySigners";

export const NotifySignersButton = () => {
  const dispatch = useDispatch();

  const [presentToast, hideToast] = useIonToast();
  const [present] = useIonAlert();

  const handleNotifySigners = async () => {
    try {
      presentToast({
        message: `Reenviando notificación...`,
        color: "primary",
      });
      const {
        payload: { success },
      }: any = await dispatch(notifySigners());
      if (!success) {
        throw new Error("No se envió la notificación");
      }
      await hideToast();
      presentToast({
        message: `Se reenvió una notificación a todos los firmantes para que firmen el acuerdo`,
        color: "success",
        duration: 8000,
      });
    } catch (error) {
      await hideToast();
      presentToast({
        message: "Ocurrió un problema enviando notificación al firmante",
        color: "danger",
        duration: 8000,
      });
    }
  };

  return (
    <IonItem
      button
      lines="none"
      onClick={() => {
        present({
          header: `¿Deseas reenviar una notificación a todos los pendientes por firmar?`,
          buttons: [
            "No",
            {
              text: "Reenviar notificación",
              handler: () => handleNotifySigners(),
            },
          ],
        });
      }}
    >
      <IonIcon icon={notificationsOutline} slot="start" />
      <span>Notificar pendientes</span>
    </IonItem>
  );
};
